export default __webpack_public_path__ + "static/media/skill9.04188fcc.svg";